export class Texture {
  public static from(image: string) {
    return new Texture(image);
  }

  public image: string;
  public tag: string;

  constructor(image: string) {
    this.image = image;
    this.tag = image.split('/').pop() ?? 'Texture';
  }

  public get width(): number {
    // console.warn('Not yet implemented: Texture.width');
    return 0;
  }

  public get height(): number {
    // console.warn('Not yet implemented: Texture.height');
    return 0;
  }
}
